/******************************************************************************
 *** SysAcntgYearSaveDialog ** 회계연도 수정 모달 * 시스템 관리자만 수정
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import Util from "@/js/common/Util";
import React from "react";

interface Props {
    acntgYear: string;
    setModalOpen: Function;
    setCallTime: Function;
}

const SysAcntgYearSaveDialog = ({ acntgYear, setModalOpen, setCallTime }: Props) => {
  const [acntgYearVal, setAcntgYearVal] = React.useState<string>(""); // 회계연도
  const [acntgBgngYmd, setAcntgBgngYmd] = React.useState<string>(""); // 회계 시작일자
  const [acntgEndYmd , setAcntgEndYmd ] = React.useState<string>(""); // 회계 종료일자
  const [inptPsbltyYn, setInptPsbltyYn] = React.useState<string>(""); // 입력 가능여부
  const [ddlnYn      , setDdlnYn      ] = React.useState<string>(""); // 마감 여부

    // 상세 조회
    React.useEffect(() => {
        AppContext.showSpinner();

        Axios.dataAccess({
            url: "system/sys/acntg/year/select-acntg-year-dtl.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                acntgYear: acntgYear,
            },
            onSuccessFn: (res: any) => {
                const item = res.result.item;
                if (Util.isNotEmpty(item)) {
                    setAcntgYearVal(item.acntgYear);
                    setAcntgBgngYmd(item.acntgBgngYmd);
                    setAcntgEndYmd(item.acntgEndYmd);
                    setInptPsbltyYn(item.inptPsbltyYn);
                    setDdlnYn(item.ddlnYn);
                }
                AppContext.hideSpinner();
            },
        });
    }, [acntgYear]);

    // 모달 닫기
    const closeModal = () => {
        setModalOpen(false);
        setCallTime(new Date());
    };

    // 회계연도 저장
    const handleSave = () => {
        AppContext.openAlert({
            title: "회계연도 수정",
            msg: "회계연도를 수정하시겠습니까?",
            icon: "warning",
            confirmText: "수정",
            handleConfirm: () => {
                AppContext.showSpinner();

                Axios.dataAccess({
                    url: "system/sys/acntg/year/save-acntg-year.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {
                        acntgYear   : acntgYearVal, // 회계연도
                        acntgBgngYmd: acntgBgngYmd, // 회계 시작일자
                        acntgEndYmd : acntgEndYmd , // 회계 종료일자
                        inptPsbltyYn: inptPsbltyYn, // 입력 가능여부
                        ddlnYn      : ddlnYn      , // 마감 여부
                    },
                    onSuccessFn: () => {
                        AppContext.hideSpinner();
                        AppContext.openAlert({
                            title: "회계연도 수정 완료",
                            msg: "회계연도 수정이 완료되었습니다.",
                            icon: "success",
                        });
                        setCallTime(new Date());
                        setModalOpen(false);
                    },
                });
            },
        });
    };

    return (
        <div className="w100p dpFlx jcC">
            <div className="w540">
                {/* 회계년도 */}
                <div className="mt10 ml10">
                    <div className="h30 dpFlx aiE pb5 bdBox">
                        <span className="fm-b fs13 ls06 fc111111">회계연도<span className="fcE60000">*</span></span>
                    </div>
                    <TextBox value={acntgYearVal}
                        width={250} height={36}
                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                        borderColor="#BFBFBF" borderOnColor="#222" borderRadius={5}
                        style={{ backgroundColor: "#F6F6F6", padding: "0 10px" }}
                        placeholder="YYYY"
                        mode={"readonly"} // PK라 수정시 고정
                        onChangeFunc={(text: string) => setAcntgYearVal(text)}
                    />
                </div>

                {/* 시작/종료일 */}
                <div className="dpFlx flxNowrap gap20 mt10 jcC">
                    <div className="w250">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">회계 시작일 <span className="fcE60000">*</span></span>
                        </div>
                        <DatePickerBox value={acntgBgngYmd}
                            width={250} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                            bgColor="#F6F6F6" textAlign="left"
                            calendarThemeColor={AppContext.themeColor}
                            className="mr5"
                            disabled={true}
                            onChange={(v: string) => setAcntgBgngYmd(v)}
                        />
                    </div>

                    <div className="w250">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">회계 종료일 <span className="fcE60000">*</span></span>
                        </div>
                        <DatePickerBox value={acntgEndYmd}
                            width={250} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                            bgColor="#F6F6F6" textAlign="left"
                            calendarThemeColor={AppContext.themeColor}
                            className="mr5"
                            disabled={true}
                            onChange={(v: string) => setAcntgEndYmd(v)}
                        />
                    </div>
                </div>

                {/* 입력가능/마감 */}
                <div className="dpFlx flxNowrap gap20 mt10 jcC">
                    <div className="w250">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">입력 가능 여부</span>
                        </div>
                        <SelectBox value={inptPsbltyYn}
                            width={250} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                            background="#fff"
                            codeArray={[
                                { code: "Y", name: "가능" },
                                { code: "N", name: "불가" },
                            ]}
                            placeholder=""
                            paddingRight={8}
                            onChangeFunc={(data: string) => setInptPsbltyYn(data)}
                        />
                    </div>

                    <div className="w250">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">마감 여부</span>
                        </div>
                        <SelectBox value={ddlnYn}
                            width={250} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                            background="#fff"
                            codeArray={[
                                { code: "Y", name: "마감 완료" },
                                { code: "N", name: "마감 전"   },
                            ]}
                            placeholder=""
                            paddingRight={8}
                            onChangeFunc={(v: string) => setDdlnYn(v)}
                        />
                    </div>
                </div>

                {/* 버튼 */}
                <div className="dpFlx jcC mt25 gap10">
                    <Button buttonName="취소"
                        width={100} height={40}
                        fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                        variant="styCancelBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        onClickFunc={closeModal}
                    />

                    <Button buttonName="수정"
                        width={120} height={40}
                        fontFamily="fm-b" fontSize={16} letterSpacing={-1} color="#fff"
                        backgroundColor="#007bff" borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        onClickFunc={handleSave}
                    />
                </div>
            </div>
        </div>
    );
};

export default SysAcntgYearSaveDialog;
